import React, { useMemo } from "react";
import Select from "react-select";

export function HrmsBranchSelect({
  branchId,
  onChangeBranchId,
  branchOptions,
  loading,
  buttonTableStyle,
  disabled,
}) {
  const selectStyles = useMemo(
    () => ({
      control: (p) => ({
        ...p,
        minHeight: 44,
        minWidth: 220,
        borderRadius: buttonTableStyle === "square" ? 0 : 8,
        borderColor: "#e0e6eb",
        boxShadow: "none",
      }),
      menu: (p) => ({ ...p, zIndex: 9999 }),
    }),
    [buttonTableStyle],
  );

  const value = useMemo(
    () => branchOptions.find((o) => Number(o.value) === Number(branchId)),
    [branchOptions, branchId],
  );

  return (
    <div className="flex-shrink-0" style={{ width: 220, minWidth: 220 }}>
      <Select
        inputId="hrms-branch-select"
        isLoading={loading}
        isDisabled={disabled || loading || !branchOptions.length}
        options={branchOptions}
        value={value || null}
        onChange={(opt) => onChangeBranchId(opt ? Number(opt.value) : null)}
        placeholder="Branch"
        styles={selectStyles}
      />
    </div>
  );
}
